import { render, staticRenderFns } from "./NewformAllInOne.vue?vue&type=template&id=1361c6f3&scoped=true&"
import script from "./NewformAllInOne.vue?vue&type=script&lang=js&"
export * from "./NewformAllInOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361c6f3",
  null
  
)

export default component.exports